import { render, staticRenderFns } from "./SingularityMilestoneComponent.vue?vue&type=template&id=1e27b670&scoped=true"
import script from "./SingularityMilestoneComponent.vue?vue&type=script&lang=js"
export * from "./SingularityMilestoneComponent.vue?vue&type=script&lang=js"
import style0 from "./SingularityMilestoneComponent.vue?vue&type=style&index=0&id=1e27b670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e27b670",
  null
  
)

export default component.exports